export const base = {
  boxSizing: 'border-box',
  fontFamily: '"Source Sans Pro", sans-serif',
}

export const baseLink = {
  textDecoration: 'none',
  color: 'inherit',
}

export const baseFont = '@import https://fonts.googleapis.com/css?family=Source+Sans+Pro;'
